<main>
  <div class="container">

    <div class="row mb-4">

      <div class="col-12 col-md-7">

        <div class="general-title">
          <h2>Modalidades de pagamento da contribuição mensal</h2>
        </div>

        <div class="text-page mt-3 mt-md-5">
          <p>
            Visando a comodidade de seus participantes o Plano Setorial Viva Mais Previdência facilita o processo de pagamentos de suas contribuições mensais da melhor maneira possível.
          </p>
          <p>
            Tendo em vista as informações acima, aponte abaixo qual a melhor forma para o pagamento de suas contribuições do Viva Mais Previdência e seguros.
          </p>
        </div>

        <div class="description-text mt-3 mt-md-5" style="height: 163px;">
          @if (tabText == 'debito') {
            <div>
              <p><strong>Débito em Conta</strong></p>
              <p>
                O débito em conta ou débito automático conta com a segurança nas transações, que são feitas online. Atualmente possuímos convênios para débito com o seguinte banco: <strong>Itaú</strong> e <strong>Caixa Econômica Federal</strong>.
              </p>
              <p>
                Para prosseguir, clique abaixo e preencha os dados dos campos solicitados.
              </p>
            </div>
          }
          @if (tabText == 'boleto') {
            <div>
              <p><strong>Boleto Bancário</strong></p>
              <p>
                Os boletos do Viva Mais Previdência podem ser pagos em qualquer entidade bancária e Casas Lotéricas.
              </p>
              <p>
                Para prosseguir, clique abaixo e selecione a data de sua preferência.
              </p>
            </div>
          }
          @if (tabText == 'folha') {
            <div>
              <p><strong>Folha de Pagamento</strong></p>
              <p>
                Esta modalidade de pagamento possibilita o desconto das contribuições Viva Mais Previdência na folha de pagamento.
                Esta é uma opção disponível apenas para participantes vinculados a Fundação Sanepar, Fusan e Sanepar, que possuam o plano Viva Mais Previdência em seu CPF.
              </p>
              <p>
                Para prosseguir clique na opção abaixo, folha de pagamento.
              </p>
            </div>
          }
        </div>

      </div>


      <div class="col-12 offset-0 col-md-3 offset-md-2">
        <div class="box w-100" style="height: auto;">
          <div class="center">
            <div class="title">Dados de Cobrança Atuais</div>
            <table>
              <tr>
                <td>Forma de pagamento:</td>
                <td>{{formaPgtoAtual?.dcrFormaPgto}}</td>
              </tr>
              <tr>
                <td>Vencimento:</td>
                <td>{{formaPgtoAtual?.diaPgto}}</td>
              </tr>
            </table>

            @if (formaPgtoAtual?.codFormaPgto=='D') {
              <div>
                <div class="title mt-3">
                  Conta Cadastrada
                  <a href="#debito" data-toggle="modal" data-target="#paymentsModal" style="font-size: 18px;" title="editar" (click)="codFormaPgtoAtual='D'; modalType='debito'; modalStep='debito_1';  listarDiasPgto()"><i class="fas fa-pen-square"></i></a>
                </div>
                <table>
                  <tr>
                    <td>Banco:</td>
                    <td>{{dadosDebitoAtual?.banco}}</td>
                  </tr>
                  @if (dadosDebitoAtual?.banco==104) {
                    <tr>
                      <td>Operação:</td>
                      <td>{{dadosDebitoAtual?.operacao}}</td>
                    </tr>
                  }
                  <tr>
                    <td>Ag.:</td>
                    <td>{{dadosDebitoAtual?.agencia}}</td>
                  </tr>
                  <tr>
                    <td>Conta:</td>
                    <td>{{dadosDebitoAtual?.conta}}-{{dadosDebitoAtual?.contaDV}}</td>
                  </tr>
                  <tr>
                    <td>Nº Débito Automático:</td>
                    <td style="word-break: break-all;">{{dadosDebitoAtual?.codCliente}}</td>
                  </tr>
                </table>
              </div>
            }

          </div>
        </div>
      </div>

    </div>

    <!-- Botões -->
    <div class="row my-3 my-md-5">
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <a href="#debito" class="btn btn-big" [ngClass]="{'btn-big-selected': codFormaPgtoAtual=='D'}" data-toggle="modal" data-target="#paymentsModal" (click)="modalType = 'debito'; codFormaPgtoAtual='D'; listarDiasPgto();" (click)="modalStep = 'debito_1'" (mouseover)="tabText = 'debito'">
          Débito em Conta
        </a>
      </div>
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <a href="#boleto" class="btn btn-big" [ngClass]="{'btn-big-selected': codFormaPgtoAtual=='B'}" data-toggle="modal" data-target="#paymentsModal" (click)="modalType = 'boleto'; codFormaPgtoAtual='B'; listarDiasPgto();" (click)="modalStep = 'boleto_1'; codFormaPgtoAtual='B'" (mouseover)="tabText = 'boleto'">
          Boleto Bancário
        </a>
      </div>

      <!--
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <a href="#folha" class="btn btn-big" [ngClass]="{'btn-big-selected': codFormaPgtoAtual=='F'}" data-toggle="modal" data-target="#paymentsModal" (click)="modalType = 'folha'; codFormaPgtoAtual='F'; listarDiasPgto();" (click)="modalStep = 'folha_1'" (mouseover)="tabText = 'folha'; codFormaPgtoAtual='F'">
          Folha de Pagamento
        </a>
      </div>
      -->

    </div>

  </div>
</main>

<div class="modal fade" id="paymentsModal">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal">
        <i class="fas fa-times"></i>
      </button>
      <div class="modal-body">

        <div class="loading">
          <i class="fas fa-spin fa-spinner"></i>
        </div>

        @if (modalType == 'debito') {
          <div>
            @if (modalStep == 'debito_1') {
              <div>
                <h2 class="title">Selecione a titularidade da conta para débito:</h2>
                <div>
                  <label>
                    <input type="radio" value="minha" name="opcaoTitularidade" [(ngModel)]="opcaoTitularidade">
                    Minha Titularidade (CPF: {{formatarCpf(cpfParticipante)}})
                  </label>
                  <br/>
                  <label>
                    <input type="radio" value="outra" name="opcaoTitularidade" [(ngModel)]="opcaoTitularidade">
                    Outra Titularidade
                  </label>
                </div>
                @if (opcaoTitularidade=='outra') {
                  <div>
                    <input type="text" class="form-control" placeholder="CPF do Titular da Conta" mask="000.000.000-00" [dropSpecialCharacters]="false" value="" [(ngModel)]="cpfRespFi" />
                  </div>
                }
                <p class="mt-3 mt-md-5 mb-3 mb-md-4">Aponte abaixo a data para o débito em conta.</p>
                <div class="row align-items-center">
                  <div class="col-auto"><label for="debitar_dia">Debitar dia:</label></div>
                  <div class="col-4">
                    <select class="form-control" id="debitar_dia" [(ngModel)]="diaPgto">
                      @for (item of diasPgto; track item) {
                        <option [value]="item.DIA_PGTO">{{item.DIA_PGTO}}</option>
                      }
                    </select>
                  </div>
                  <div class="col text-right mt-3 mt-mb-0">
                    <button class="btn btn-primary" (click)="verificarCPFRespFinanceiro()" [disabled]="loading || (opcaoTitularidade=='outra' && cpfRespFi.length < 11)">
                      Próximo
                      @if (loading) {
                        <i class="fas fa-spinner fa-spin"></i>
                      }
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (modalStep == 'debito_2') {
              <div>
                @if (formRespFi!=null) {
                  <form [formGroup]="formRespFi">
                    <h2 class="title">Preencha os campos abaixo com as informações do responsável financeiro:</h2>
                    <div class="row">
                      <div class="col-12">
                        <input class="mb-3 form-control" type="text" placeholder="CPF" formControlName="cpf">
                        <input class="mb-3 form-control" type="text" placeholder="Nome" formControlName="nome">
                        <input class="mb-3 form-control" type="text" placeholder="(41) 999999999" mask="(00) 000000000" formControlName="celular">
                        <input class="mb-3 form-control" type="email" placeholder="E-mail" formControlName="email">
                      </div>
                    </div>
                  </form>
                }
                <div class="row align-items-center">
                  <div class="col text-right">
                    <button class="btn btn-primary" (click)="modalStep = 'debito_3'" [disabled]="!formRespFi.valid">Próximo</button>
                  </div>
                </div>
              </div>
            }
            @if (modalStep == 'debito_3') {
              <div>
                @if (formDebConta!=null) {
                  <form [formGroup]="formDebConta">
                    <h2 class="title">Cadastre as informações da Conta Corrente:</h2>
                    <div class="row mb-3">
                      <div class="col-12">
                        <div class="row mb-3">
                          <div class="col-12">
                            <select id="banco_conta" class="form-control" formControlName="banco" (change)="onBancoChange($event.target.value)">
                              @for (item of bancosDebitoConta; track item) {
                                <option [value]="item.NUM_BANCO">{{item.NOM_BANCO}} ({{item.NUM_BANCO}})</option>
                              }
                            </select>
                          </div>
                        </div>
                        @if (exibiCodOperacao) {
                          <div class="row mb-3">
                            <div class="col-12">
                              <input class="form-control" type="text" mask="009" placeholder="Código da Operação" formControlName="operacao">
                            </div>
                          </div>
                        }
                        <div class="row mb-3">
                          <div class="col-12">
                            <input class="form-control" type="text" mask="0009" placeholder="Agência" formControlName="agencia">
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-9">
                            <input class="form-control" type="text" mask="0009999999" placeholder="Conta Corrente" formControlName="conta">
                          </div>
                          <div class="col-1">
                            -
                          </div>
                          <div class="col-2">
                            <input class="form-control" type="text" mask="0" placeholder="DV" formControlName="contaDV">
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                }
                <div class="row align-items-center">
                  <div class="col text-right">
                    <button class="btn btn-primary" (click)="modalStep = 'debito_4'" [disabled]="!formDebConta.valid">Próximo</button>
                  </div>
                </div>
              </div>
            }
            @if (modalStep == 'debito_4') {
              <div>
                <div class="icon-center">
                  <i class="far fa-question-circle"></i>
                </div>
                <h3 class="title my-3 my-md-5">
                  Confirma a realização desta ação?
                </h3>
                <div class="row mb-3">
                  <div class="col-12">
                    <label>
                      <input type="checkbox" [(ngModel)]="decDebitoConta" class="form-check-input" value="autorizo" name="autorizo" style="position: relative; margin: 0;" />
                      Declaro verdadeiras e assumo as responsabilidades pelas informações preenchidas para débito dos valores correspondente ao plano Viva Mais Previdência e ao Seguro.
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col text-left">
                    <button class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                  </div>
                  <div class="col text-right">
                    <div class="input-group col-md-12 gp-assinatura">
                      <input type="password" class="form-control" placeholder="Assinatura Eletrônica" [(ngModel)]="assinatura">
                      <div class="input-group-append">
                        <button class="btn btn-success" type="button" (click)="inserirDebitoConta()" [disabled]="assinatura.length < 1 || loading || !decDebitoConta">
                          Salvar
                          @if (loading) {
                            <i class="fas fa-spinner fa-spin"></i>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (modalStep == 'debito_5') {
              <div>
                <div class="icon-center small">
                  <i class="far fa-check-circle"></i>
                </div>
                <h3 class="title my-2 my-md-4">
                  Alteração realizada com sucesso!
                </h3>
                <h4 class="subtitle my-4">
                  Código da operação: <strong>{{dadosDebitoAtual?.codCliente}}</strong>
                </h4>
                <h4 class="subtitle my-4">
                  Forma de pagamento vigente a partir da competência de <strong>{{proximaDataDebitoConta| date:"dd/MM"}}</strong>.
                </h4>
                <p><strong>Com o código gerado, acesse o aplicativo do banco ou dirija-se a agência bancária, para liberação do débito automático.</strong></p>
              </div>
            }
          </div>
          }<!--debito-->

          @if (modalType == 'boleto') {
            <div>
              @if (modalStep == 'boleto_1') {
                <div>
                  <h2 class="title">Selecione a data para o vencimento do boleto:</h2>
                  <div class="row align-items-center my-3 my-md-5">
                    <div class="col-auto"><label for="vencimento_dia">Vencimento dia:</label></div>
                    <div class="col-4">
                      <select class="form-control" id="vencimento_dia" [(ngModel)]="diaPgto">
                        @for (item of diasPgto; track item) {
                          <option [value]="item.DIA_PGTO">{{item.DIA_PGTO}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-right">
                      <button class="btn btn-primary" (click)="modalStep = 'boleto_2'">Próximo</button>
                    </div>
                  </div>
                </div>
              }
              @if (modalStep == 'boleto_2') {
                <div>
                  <div class="icon-center">
                    <i class="far fa-question-circle"></i>
                  </div>
                  <h3 class="title my-3 my-md-5">
                    Confirma a realização desta ação?
                  </h3>
                  <div class="row">
                    <div class="col text-left">
                      <button class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                    <div class="col text-right">
                      <div class="input-group col-md-12 gp-assinatura">
                        <input type="password" class="form-control" placeholder="Assinatura Eletrônica" [(ngModel)]="assinatura">
                        <div class="input-group-append">
                          <button class="btn btn-success" type="button" (click)="inserirBoleto()" [disabled]="assinatura.length < 1 || loading">
                            Salvar
                            @if (loading) {
                              <i class="fas fa-spinner fa-spin"></i>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (modalStep == 'boleto_3') {
                <div>
                  <div class="icon-center small">
                    <i class="far fa-check-circle"></i>
                  </div>
                  <h3 class="title my-2 my-md-4">
                    Alteração realizada com sucesso!
                  </h3>
                  <p class="text-center">Forma de pagamento vigente a partir do vencimento <strong>{{proximaDataVencBoleto| date:"dd/MM"}}</strong></p>
                </div>
              }
            </div>
          }
          @if (modalType == 'folha') {
            <div>
              @if (modalStep == 'folha_1') {
                <div>
                  <div class="icon-center">
                    <i class="far fa-question-circle"></i>
                  </div>
                  <h3 class="title my-3 my-md-5">
                    Confirma a realização desta ação?
                  </h3>
                  <div class="row mb-3">
                    <div class="col-12">
                      <label>
                        <input type="checkbox" [(ngModel)]="decDescontoFolha" class="form-check-input" value="autorizo" name="autorizo" style="position: relative; margin: 0;" />
                        Declaro verdadeiras e assumo as responsabilidades pelas informações preenchidas para débito dos valores correspondente ao plano Viva Mais Previdência.
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      <button class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                    <div class="col text-right">
                      <div class="input-group col-md-12 gp-assinatura">
                        <input type="password" class="form-control" placeholder="Assinatura Eletrônica" [(ngModel)]="assinatura">
                        <div class="input-group-append">
                          <button class="btn btn-success" type="button" (click)="inserirDebitoFolha()" [disabled]="assinatura.length < 1 || loading || !decDescontoFolha">
                            Salvar
                            @if (loading) {
                              <i class="fas fa-spinner fa-spin"></i>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (modalStep == 'folha_2') {
                <div>
                  <div class="icon-center small">
                    <i class="far fa-check-circle"></i>
                  </div>
                  <h3 class="title my-2 my-md-4">
                    Alteração realizada com sucesso!
                  </h3>
                  <p class="text-center">Forma de pagamento vigente a partir do vencimento <strong>{{proximaDataDescFolha| date:"dd/MM"}}</strong></p>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>